export { default } from './res'

import './res.en'
import './res.kk'
import './res.ru'
